// src/admin/AdminNav/AdminNav.jsx
import React from "react";
import {Link} from "react-router-dom";
import "./AdminNav.css";

function AdminNav() {
    return (
        <nav className="admin-nav">
            <ul className="nav-list">
                {/* PRODUKTER */}
                <li className="nav-item">
                    <Link to="/admin/product" className="nav-link">
                        SKAPA RECEPT
                    </Link>
                </li>
                <li className="nav-item">
                    <Link to="/admin/recipes-page" className="nav-link">
                        RECEPT HANTERING
                    </Link>
                </li>
                <li className="nav-item">
                    <Link to="/admin/food-items" className="nav-link">
                        MATVAROR
                    </Link>
                </li>

                {/* BESTÄLLNINGAR Dropdown */}
                <li className="nav-item dropdown">
                    <span className="nav-link">BESTÄLLNINGAR</span>
                    <ul className="dropdown-menu">
                        <li>
                            <Link to="/admin/orders" className="dropdown-link">
                                Ej Klara
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/done-orders" className="dropdown-link">
                                Färdiga
                            </Link>
                        </li>
                    </ul>
                </li>
                <li className="nav-item">
                    <Link to="/admin/statistics" className="nav-link">
                        STATSTIK
                    </Link>
                </li>
            </ul>
        </nav>
    );
}

export default AdminNav;
